//优先推荐
import { message } from "antd";
import { useState } from "react";
import { changeHouseprioritized } from "../../../../api/api";

const Prioritized = (props) => {
  const { id, setIsFresh, value } = props;
  const changeStatus = () => {
    changeHouseprioritized(id, Number(!value)).then((res) => {
      console.log(id, value);
      value === 0
        ? message.success("成功在广告活动中进行优先推荐")
        : message.success("已取消在广告活动中优先推荐");
      setIsFresh((pre) => {
        console.log("fresh!", pre);
        return !pre;
      });
    });
  };
  return (
    <div>
      <a onClick={changeStatus}>{value === 0 ? "优先推荐" : "取消优先"}</a>
    </div>
  );
};

export default Prioritized;
